export default "__VITE_ASSET__CQXsavr3__"